"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    placementContextHandler: ()=>placementContextHandler
});
require("react");
function placementContextHandler(wsRef, realtimeContext) {
    const { requestFrom } = realtimeContext;
    switch(requestFrom){
        case 'travel-itinerary':
            const { offerToken, offerNumber, cguid, rguid, productId } = realtimeContext ?? {};
            wsRef.current.sendMessage({
                type: 'realtime_client_context',
                data: {
                    offerNumber,
                    offerToken,
                    requestFrom,
                    cguid,
                    rguid,
                    productId
                }
            });
            break;
        case 'hotelListingPage':
        case 'productListingPage':
            const { listingContext } = realtimeContext ?? {};
            if (listingContext?.hotelPayload?.availableHotelsOnListing?.length) wsRef.current.sendMessage({
                type: 'realtime_client_context',
                data: {
                    listingContext,
                    requestFrom
                }
            });
            break;
        case 'hotelDetailPage':
        case 'productDetailPage':
            const { detailsContext, hotelName } = realtimeContext ?? {};
            if (detailsContext) wsRef.current.sendMessage({
                type: 'realtime_client_context',
                data: {
                    detailsContext,
                    requestFrom,
                    hotelName
                }
            });
            break;
        case 'rcListingsPage':
            const { rcListingsContextStr } = realtimeContext ?? {};
            if (rcListingsContextStr) wsRef.current.sendMessage({
                type: 'realtime_client_context',
                data: {
                    rcListingsContextStr,
                    requestFrom
                }
            });
            break;
        default:
            break;
    }
}
exports.placementContextHandler = __webpack_exports__.placementContextHandler;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "placementContextHandler"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
